<template>
  <div class="home">
     <v-col style="background:#fff;" class="text-center" >
       <router-link to="/">
      <img width="300px" src="../assets/logo.png" alt="">
       </router-link>
    </v-col>
    <marquee />
    <covid-row />
    <v-row align="center" dense class="d-flex d-sm-none">
      <v-col md6>
        <recent-cards />
      </v-col>
    </v-row>
    <v-row no-gutters>
    <v-col cols="12" sm="12" md="2" class="hidden-sm-and-down" align="center">
        <covid />
       <cards />
    </v-col>
    <v-col cols="12" sm="12" md="8" align="center">
      <WebViewer :path="`${publicPath}lib`" :url="this.$pdfurl+this.epaper.epaper_file"/>
    </v-col>
    <v-col cols="12" sm="12" md="2" align="center">
        <v-card max-width="300" height="400">

        <v-date-picker width="300" v-model="picker"
        year-icon="mdi-calendar-blank"
        prev-icon="mdi-skip-previous"
        next-icon="mdi-skip-next" 
        @change="getSelected"
        :max="this.$currentDate">
        </v-date-picker>
        </v-card>

        <weather/>
    
    </v-col>
  </v-row>
		
		
		

    
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import WebViewer from '../components/WebViewer.vue'
import Mainaxios from '../Api'
import Weather from '../components/Weather.vue';
import Cards from '../components/Cards.vue';
import RecentCards from '../components/RecentCards.vue';
import Covid from '../components/Covid.vue';
import Marquee from '../components/Marquee.vue';
import CovidRow from '../components/CovidRow.vue';

export default {
  name: 'App',
  components: {
    WebViewer, Weather, Cards, RecentCards,
    Covid, Marquee, CovidRow
  },

  data: () => ({
    // publicPath: "http://localhost:8080/",
    publicPath: "https://www.pressmediaenglishdaily.com/",
    epaper:null,
    picker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
  }),
  watch:{
    picker(){
      console.log(this.picker)
      this.getEpaper(this.picker)
    }
  },
  created () {
      this.getFile();
    },
  methods:{
    async getFile(){
       await Mainaxios.get("api/epaper").then(({data}) => (this.epaper = data,
       this.url=this.$pdfurl+data.epaper_file));
    },
    async getSelected(){
       await Mainaxios.get("api/epaper/"+this.picker).then(({data}) => (this.epaper = data
       ));
    },
    getEpaper(id){
        this.$router.push('/epaper/'+id)
    }
  }
};
</script>
<style scoped>
body{
  --secondary-color: #fff;
}
#app{
  background-color: #4D4C5F;
}
.footer-link{
  text-decoration: none;
  color: #9e9e9e;
  font-weight: 500;
}
</style>
